class ShopifyAdapterService {
  static _tenantId = 77;
  static shopifyAdapterUrl = `https://api.eu.customerscanvashub.com/api/shopify-adapter/v1`;

  static async getRawProject(projectId) {
    const tenantId = ShopifyAdapterService._tenantId;
    const legacyRawProjectUrl = `/legacy-raw-projects?tenantId=${tenantId}&id=${projectId}`;
    // Sample: https://sh-adapter.customerscanvashub.com/api/shopify-adapter/v1/legacy-raw-projects?tenantId=xx&id=xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx
    const url = `${ShopifyAdapterService.shopifyAdapterUrl}${legacyRawProjectUrl}`;
    return fetch(url).then((res) => res.json());
  };

  static async getPreview(projectId) {
    try {
      const rawProject = await ShopifyAdapterService.getRawProject(projectId);
      const lineItem = rawProject.line_items[0];
      const preview = lineItem?.properties?._hidden?.images[0];
      return preview;
    } catch(ex) {
      console.error(ex);
      return ex;
    }
  }
  
}

//const lineItems = {{ cart.items | json }};
//
//lineItems.forEach(async (lineItem) => {
//  const projectId = lineItem.properties?._projectId;
//  
//  if (!projectId) return;
//  
//  // GET PREVIEW
//  const preview = await ShopifyAdapterService.getPreview(projectId);
//});